import { useState } from "react";
import { SubmeterPlanilhaStyle } from "../SubmeterPlanilha/style";
import BatchService from "../../services/BatchService";
import Modal from "../FlexFreteModal/Modal";

function SubmeterPlanilhaNfe() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ textMessage: "", type: "", code: "" });
  const [confirmarEnvio, setConfirmarEnvio] = useState(false);

  const batchService = new BatchService();

  const modalTitle = "Enviar Planilha de NF-e?";
  const modalContent = "Deseja enviar a planilha de Notas Fiscais para processamento?";

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (
      selectedFile &&
      (selectedFile.name.endsWith(".xlsx") || selectedFile.name.endsWith(".xls"))
    ) {
      setFile(selectedFile);
      setMessage("");
    } else {
      setMessage("Selecione um arquivo .xlsx ou .xls");
      setFile(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage({ textMessage: "Nenhum arquivo selecionado", type: "erro", code: "" });
      return;
    }

    setLoading(true);
    setMessage({ textMessage: "", type: "", code: "" });

    batchService.postEnviarBatchNfe(file, (erro, sucesso) => {
      if (erro) {
        const errorMessage =
          erro.response?.data?.message || erro.message || "Erro ao enviar planilha de NF-e.";
        const errorCode = erro.response?.data?.code || erro.code;
        setMessage({
          textMessage: errorMessage,
          type: "erro",
          code: errorCode,
        });
      } else if (sucesso) {
        setMessage({
          textMessage: "Planilha de NF-e enviada com sucesso!",
          type: "sucesso",
          code: "",
        });
        setFile(null);
      }
      setLoading(false);
    });
  };

  const callbackModal = () => {
    if (confirmarEnvio === true) {
      setConfirmarEnvio(false);
    }
  };

  const confirmaEnvio = () => {
    setConfirmarEnvio(true);
  };

  const confirmarAcao = () => {
    handleUpload();
    setConfirmarEnvio(false);
  };

  return (
    <>
      <SubmeterPlanilhaStyle>
        <div className="batch-container">
          <h2 className="batch-container-title page-title">Submeter Planilha de NF-e</h2>
          <div className="upload-container">
            <div className="file-container">
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
                disabled={loading}
                className="input"
              />
            </div>
            <button
              onClick={confirmaEnvio}
              disabled={!file || loading}
              className="button upload-button"
            >
              {loading ? "Enviando..." : "Enviar Arquivo"}
            </button>
          </div>
          <div className="message-group">
            {message.type === "erro" && message.code ? (
              <p className="status-message status-error">{message.code}</p>
            ) : null}
            <p
              className={`status-message ${
                message.type === "erro" || message.type === "aviso"
                  ? "status-error"
                  : message.type === "sucesso"
                  ? "status-success"
                  : ""
              }`}
            >
              {message.textMessage}
            </p>
          </div>
        </div>
      </SubmeterPlanilhaStyle>
      {confirmarEnvio ? (
        <Modal
          callbackModal={callbackModal}
          visivel={confirmarEnvio !== null}
          titulo={modalTitle}
          conteudo={modalContent}
          botaoConfirmar
          confirmarAcaoCallback={confirmarAcao}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default SubmeterPlanilhaNfe;
